import React, { Component } from 'react'
import { LinkedInput, LinkedToggle, Modal} from 'components/basic'
import { Creatable } from 'react-select'

class CharacteristicsWidget extends Component {
  constructor (props) {
    super(props)
    this.state = {
      characteristics: null,
      editable: false
    }
  }
  componentDidMount () {
    if (!this.props.characteristics) return
    this.setCharacteristics(this.props)
    if (this.props.getCharacteristics) this.props.getCharacteristics(this.callback.bind(this))
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return
    this.setCharacteristics(props)
  }
  setCharacteristics (props) {
    if  (!props.characteristics) return
    var c = {}
    Object.entries(props.characteristics).map(([key, value]) => {
      c[key] = {
        options: value.values.map(v => {
          return {
            value: v
          }
        }),
        required: value.required,
        value: (value.value ? value.value : ''),
        type: value.type
      }
    })
    this.setState({characteristics: c, editable: props.editable})
  }

  callback () {
    return this.state.characteristics
  }

  getValue (value) {
    if (value === 'true') return true
    if (value === 'false') return false
    return value
  }

  render () {
    if (!this.state.characteristics) return false
    return (
      <div>
        {this.state.characteristics && Object.entries(this.state.characteristics).map(([key, value]) => {
          if (value.options === undefined) return
          if (value.type === 'boolean') return (
            <div className='col-md-12' key={key}>
              <label>{key}</label>
              <LinkedToggle disabled={!this.state.editable} name={value.value.toString().toUpperCase()} context={this} path={'characteristics.'+ key + '.value'} />
            </div>
          )
          return (
            <div className='col-md-12' key={key}>
              <label>{key}</label>
              <Creatable
                disabled={!this.state.editable}
                shouldKeyDownEventCreateNewOption={(keycode) => {
                  return keycode === 13
                }}
                labelKey='value'
                valueKey='value'
                options={this.state.characteristics[key].options}
                value={this.state.characteristics[key]}
                promptTextCreator={option => option}
                onChange={e => {
                  this.setState({characteristics: {
                    ...this.state.characteristics,
                    [key]: {...this.state.characteristics[key],
                      value: (e !== null ? e.value : ''),
                    }
                  }})
                }}
              />
            </div>
          )
        })}
      </div>
    )
  }
}

export default CharacteristicsWidget



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/access/CharacteristicsWidget.js